import { chakra } from '@stockx/ui';

export const NavBarInner = chakra('div', {
  baseStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '48px',

    '&.social-confirm': {
      justifyContent: 'center',
    },
  },
});
